import React, { useMemo } from 'react';
import Loader from '../../common/Loader';
import CourseSlider from './CourseSlider';
import {
  DURATION_BUCKETS,
  PRICE_BUCKETS,
  getCourseHours,
  getCoursePrice,
  getCourseTransmission,
} from './courseFilterUtils';

const CourseList = ({ Courses, Loading, filters, sortBy }) => {
  const filteredCourses = useMemo(() => {
    const durationBucket = DURATION_BUCKETS.find(
      (b) => b.value === filters.duration
    );
    const priceBucket = PRICE_BUCKETS.find((b) => b.value === filters.price);

    return Courses.filter((course) => {
      const transmission = getCourseTransmission(course);

      if (filters.courseType !== 'all' && transmission !== filters.courseType)
        return false;
      if (
        filters.transmission !== 'all' &&
        transmission !== filters.transmission
      ) {
        return false;
      }

      if (durationBucket?.test && !durationBucket.test(getCourseHours(course)))
        return false;
      if (priceBucket?.test && !priceBucket.test(getCoursePrice(course)))
        return false;

      return true;
    });
  }, [Courses, filters]);

  const sortedCourses = useMemo(() => {
    const list = [...filteredCourses];

    switch (sortBy) {
      case 'price-asc':
        return list.sort((a, b) => getCoursePrice(a) - getCoursePrice(b));
      case 'price-desc':
        return list.sort((a, b) => getCoursePrice(b) - getCoursePrice(a));
      case 'duration-asc':
        return list.sort((a, b) => getCourseHours(a) - getCourseHours(b));
      default:
        return list;
    }
  }, [filteredCourses, sortBy]);

  return (
    <>
      {Loading && <Loader />}
      <section className="course-style-three alternat-2 course-sliders-section">
        <div className="shape">
          <div
            className="shape-1"
            style={{ backgroundImage: 'url(assets/images/shape/shape-87.png)' }}
          />
          <div
            className="shape-3 float-bob-x"
            style={{ backgroundImage: 'url(assets/images/shape/shape-6.png)' }}
          />
        </div>
        <div className="auto-container">
          {sortedCourses.length === 0 ? (
            <div className="col-12 text-center py-5">
              <h4>No courses match the selected filters.</h4>
            </div>
          ) : (
            <CourseSlider title="Our Courses" courses={sortedCourses} />
          )}
        </div>
      </section>
    </>
  );
};

export default CourseList;
